export default __webpack_public_path__ + "static/sport-5789b5e4600c01bbbd305912fd03757d.jpg";